export const translations = {
  en: {
    nav: {
      home: "Home",
      packages: "Party Packages",
      gallery: "Gallery",
      contract: "Contract & Payment",
      contact: "Contact",
      login: "Login",
      logout: "Logout",
      bookNow: "Book Now",
      dashboard: "Dashboard",
      admin: "Admin",
    },
    home: {
      heroTitle: "The Perfect Space for Your Children's Party",
      heroDescription: "We offer a cozy and modern cafe for rent, where you can bring to life any ideas for a perfect children's birthday or family event. Our format is complete creative freedom for organizers and a safe environment for little guests.",
      explorePackages: "Explore Packages",
      unforgettableBirthdays: "UNFORGETTABLE BIRTHDAYS",
      pickYourMagic: "Pick Your Magic!",
      pickDescription: "Choose the perfect party package for your child's special day. We handle the space, you make the memories!",
      mostPopular: "MOST POPULAR",
      bestValue: "BEST VALUE",
      perParty: "/party",
      viewAllPackages: "View All Packages",
      featuresTitle: "Features of Our Space",
      featureFormat: "Format",
      featureFormatDesc: "Venue rental without outside staff. You plan the scenario and decor yourself.",
      featureFood: "Food",
      featureFoodDesc: "You can bring any favorite treats, snacks and desserts with you. The cafe does not provide food.",
      featureDrinks: "Drinks",
      featureDrinksDesc: "Only non-alcoholic drinks (juices, lemonades, tea/coffee). The cafe does not provide beverages.",
      featureAtmosphere: "Atmosphere",
      featureAtmosphereDesc: "\"Sober format\" - an alcohol-free zone.",
      popularThemes: "Party Themes",
      themesDescription: "Choose from our popular celebration themes for birthdays and children's holidays!",
      viewDetails: "Book Now",
      readyToCreate: "Ready to Create Magical Memories?",
      readyDescription: "Book your party today and bring your own magic to our space!",
      bookYourParty: "Book Your Party",
    },
    booking: {
      title: "BOOK YOUR PARTY",
      heading: "Book a Magical Party!",
      subtitle: "Let's make your child's birthday unforgettable",
      step1: "1. Select Package",
      step2: "2. Pick Date & Time",
      step3: "3. Party Details",
      workingHours: "Working hours: 12:00 - 22:00 (including weekends)",
      partyDate: "Party Date",
      partyTime: "Party Time",
      selectDatePlaceholder: "Select date",
      selectTimePlaceholder: "Select time",
      childName: "Birthday Child's Name",
      childAge: "Child's Age",
      parentName: "Parent/Guardian Name",
      phone: "Phone Number",
      email: "Email Address",
      guests: "Number of Guests",
      specialRequests: "Special Requests (Optional)",
      specialRequestsPlaceholder: "Any dietary restrictions, theme preferences, or special requests...",
      summary: "Booking Summary",
      packageLabel: "Package",
      priceLabel: "Price",
      dateLabel: "Date",
      timeLabel: "Time",
      total: "Total",
      submitButton: "Send Booking Request",
      sending: "Sending...",
      confirmation: "We will contact you within 24 hours to confirm your booking",
      selectDate: "Please select a party date",
      selectTime: "Please select a party time",
      success: "Booking request sent successfully! We will contact you soon.",
      error: "Failed to send booking. Please try again or contact us directly.",
    },
    contact: {
      badge: "CONTACT US",
      title: "Get In Touch",
      subtitle: "Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
      visitUs: "Visit Us",
      address: "Burgas, Bulgaria",
      callUs: "Call Us",
      emailUs: "Email Us",
      replyTime: "We reply within 24 hours",
      openingHours: "Opening Hours",
      workingHours: "12:00 - 22:00",
      includesWeekends: "Including weekends",
      formTitle: "Send Us a Message",
      yourName: "Your Name",
      emailAddress: "Email Address",
      phoneNumber: "Phone Number",
      subject: "Subject",
      message: "Message",
      messagePlaceholder: "Tell us how we can help you...",
      sendMessage: "Send Message",
      sending: "Sending...",
      success: "Message sent successfully! We will contact you soon.",
      error: "Failed to send message. Please try again.",
    },
    packages: {
      title: "Choose Your Perfect Package",
      description: "Every package includes our cozy and modern space. Just pick your favorite and bring your own magic!",
      readyToBook: "Ready to Book?",
      readyDescription: "Select your package and let's start planning the most memorable birthday party!",
      bookNow: "Book Your Party Now",
    },
    dashboard: {
      welcomeBack: "Welcome back",
      manageBookings: "Manage your bookings and view your party history",
      totalBookings: "Total Bookings",
      upcoming: "Upcoming",
      totalSpent: "Total Spent",
      account: "Account",
      active: "Active",
      myBookings: "My Bookings",
      paymentHistory: "Payment History",
      paymentId: "Payment ID",
      bookingId: "Booking ID",
      date: "Date",
      time: "Time",
      amount: "Amount",
      method: "Method",
      status: "Status",
      viewDetails: "View Details",
      guests: "Guests",
      package: "Package",
      addOns: "Add-ons",
      confirmed: "CONFIRMED",
      pending: "PENDING",
      completed: "COMPLETED",
      cancelled: "CANCELLED",
      paid: "PAID",
    },
    admin: {
      title: "Admin Dashboard",
      description: "Manage your Children Planet business",
      totalUsers: "Total Users",
      totalBookings: "Total Bookings",
      totalRevenue: "Total Revenue",
      galleryImages: "Gallery Images",
      packages: "Packages",
      bookings: "Bookings",
      users: "Users",
      gallery: "Gallery",
      managePackages: "Manage Packages",
      addPackage: "Add Package",
      allBookings: "All Bookings",
      userManagement: "User Management",
      userManagementDesc: "User management features will be available soon",
      viewEditUsers: "View, edit, and manage all registered users",
      galleryManagement: "Gallery Management",
      uploadPhoto: "Upload Photo",
      featuresIncluded: "features included",
      save: "Save",
      cancel: "Cancel",
      view: "View",
      delete: "Delete",
      edit: "Edit",
      packageName: "Package Name",
      price: "Price",
    },
    footer: {
      description: "Creating magical birthday memories since 2018. We provide the space, you bring the magic!",
      quickLinks: "Quick Links",
      support: "Support",
      visitUs: "Visit Us",
      contactUs: "Contact Us",
      contractPayment: "Contract & Payment",
      allRightsReserved: "All rights reserved.",
      partyPackages: "Party Packages",
      bookAParty: "Book a Party",
      address: "Burgas, Bulgaria",
      workingHours: "12:00 - 22:00 (incl. weekends)",
    },
    contract: {
      badge: "CONTRACT & PAYMENT",
      title: "Contract and Payment",
      subtitle: "Download our rental contract and learn about payment options",
      downloadTitle: "Rental Contract",
      downloadDesc: "Download the contract in your preferred language",
      downloadButton: "Download Contract (PDF)",
      otherLanguages: "Download in other languages:",
      paymentTitle: "Payment Information",
      paymentDesc: "We accept the following payment methods",
      acceptedMethods: "Accepted Payment Methods",
      cash: "Cash",
      bankTransfer: "Bank Transfer",
      downPaymentTitle: "Down Payment Required",
      downPaymentDesc: "A down payment is required to confirm your booking",
      downPaymentAmount: "of total amount",
      paymentNote: "The remaining 50% is due on the day of the event",
      questions: "Have questions?",
      contactUs: "Contact us",
    },
    login: {
      welcome: "Welcome! Please login to your account.",
      login: "Login",
      register: "Register",
      emailAddress: "Email Address",
      password: "Password",
      fullName: "Full Name",
      confirmPassword: "Confirm Password",
      signIn: "Sign In",
      signingIn: "Signing In...",
      createAccount: "Create Account",
      creatingAccount: "Creating Account...",
      demoCredentials: "Demo Credentials:",
      admin: "Admin",
      termsAgreement: "By continuing, you agree to our",
      termsOfService: "Terms of Service",
      and: "and",
    },
  },
  bg: {
    nav: {
      home: "Начало",
      packages: "Партита",
      gallery: "Галерия",
      contract: "Договор и плащане",
      contact: "Контакти",
      login: "Вход",
      logout: "Изход",
      bookNow: "Резервирай",
      dashboard: "Табло",
      admin: "Админ",
    },
    home: {
      heroTitle: "Идеалното пространство за вашето детско парти",
      heroDescription: "Предлагаме уютно и модерно кафе под наем, където можете да реализирате всякакви идеи за перфектен детски рожден ден или семейно събитие. Нашият формат е пълна творческа свобода за организаторите и безопасна среда за малките гости.",
      explorePackages: "Разгледай пакетите",
      unforgettableBirthdays: "НЕЗАБРАВИМИ РОЖДЕНИ ДНИ",
      pickYourMagic: "Избери своята магия!",
      pickDescription: "Изберете перфектния партийен пакет за специалния ден на вашето дете. Ние осигуряваме пространството, вие създавате спомените!",
      mostPopular: "НАЙ-ПОПУЛЯРЕН",
      bestValue: "НАЙ-ДОБРА СТОЙНОСТ",
      perParty: "/парти",
      viewAllPackages: "Виж всички пакети",
      featuresTitle: "Особености на нашето пространство",
      featureFormat: "Формат",
      featureFormatDesc: "Наем на помещение без външен персонал. Вие сами планирате сценария и декора.",
      featureFood: "Храна",
      featureFoodDesc: "Можете да донесете любимите си лакомства, закуски и десерти. Кафето не предоставя храна.",
      featureDrinks: "Напитки",
      featureDrinksDesc: "Само безалкохолни напитки (сокове, лимонади, чай/кафе). Кафето не предоставя напитки.",
      featureAtmosphere: "Атмосфера",
      featureAtmosphereDesc: "\"Трезвен формат\" - територия без алкохол.",
      popularThemes: "Парти теми",
      themesDescription: "Изберете от нашите популярни теми за празнуване на рождени дни и детски празници!",
      viewDetails: "Резервирай сега",
      readyToCreate: "Готови ли сте да създадете магически спомени?",
      readyDescription: "Резервирайте партито си днес и донесете своята магия в нашето пространство!",
      bookYourParty: "Резервирай партито си",
    },
    booking: {
      title: "РЕЗЕРВИРАЙ ПАРТИ",
      heading: "Резервирай магическо парти!",
      subtitle: "Нека направим рождения ден на вашето дете незабравим",
      step1: "1. Избери пакет",
      step2: "2. Избери дата и час",
      step3: "3. Детайли за партито",
      workingHours: "Работно време: 12:00 - 22:00 (включително почивни дни)",
      partyDate: "Дата на партито",
      partyTime: "Час на партито",
      selectDatePlaceholder: "Избери дата",
      selectTimePlaceholder: "Избери час",
      childName: "Име на рожденика",
      childAge: "Възраст на детето",
      parentName: "Име на родител/настойник",
      phone: "Телефонен номер",
      email: "Имейл адрес",
      guests: "Брой гости",
      specialRequests: "Специални заявки (по избор)",
      specialRequestsPlaceholder: "Диетични ограничения, предпочитания за тема или специални заявки...",
      summary: "Резюме на резервацията",
      packageLabel: "Пакет",
      priceLabel: "Цена",
      dateLabel: "Дата",
      timeLabel: "Час",
      total: "Общо",
      submitButton: "Изпрати заявка за резервация",
      sending: "Изпращане...",
      confirmation: "Ще се свържем с вас в рамките на 24 часа, за да потвърдим резервацията",
      selectDate: "Моля, изберете дата за партито",
      selectTime: "Моля, изберете час за партито",
      success: "Заявката за резервация е изпратена успешно! Ще се свържем с вас скоро.",
      error: "Неуспешно изпращане на резервация. Моля, опитайте отново или се свържете директно с нас.",
    },
    contact: {
      badge: "СВЪРЖЕТЕ СЕ С НАС",
      title: "Свържете се с нас",
      subtitle: "Имате въпроси? Ще се радваме да ви чуем. Изпратете ни съобщение и ще отговорим възможно най-скоро.",
      visitUs: "Посетете ни",
      address: "Бургас, България",
      callUs: "Обадете се",
      emailUs: "Пишете ни",
      replyTime: "Отговаряме в рамките на 24 часа",
      openingHours: "Работно време",
      workingHours: "12:00 - 22:00",
      includesWeekends: "Включително почивни дни",
      formTitle: "Изпратете ни съобщение",
      yourName: "Вашето име",
      emailAddress: "Имейл адрес",
      phoneNumber: "Телефонен номер",
      subject: "Тема",
      message: "Съобщение",
      messagePlaceholder: "Кажете ни как можем да ви помогнем...",
      sendMessage: "Изпрати съобщение",
      sending: "Изпращане...",
      success: "Съобщението е изпратено успешно! Ще се свържем с вас скоро.",
      error: "Неуспешно изпращане на съобщение. Моля, опитайте отново.",
    },
    packages: {
      title: "Изберете вашия перфектен пакет",
      description: "Всеки пакет включва нашето уютно и модерно пространство. Просто изберете любимия си и донесете своята магия!",
      readyToBook: "Готови за резервация?",
      readyDescription: "Изберете вашия пакет и нека да започнем да планираме най-запомнящото се партито!",
      bookNow: "Резервирай сега",
    },
    dashboard: {
      welcomeBack: "Добре дошли отново",
      manageBookings: "Управлявайте вашите резервации и преглеждайте историята на вашите партита",
      totalBookings: "Общо резервации",
      upcoming: "Предстоящи",
      totalSpent: "Общо харчено",
      account: "Акаунт",
      active: "Активен",
      myBookings: "Моите резервации",
      paymentHistory: "История на плащанията",
      paymentId: "ID на плащане",
      bookingId: "ID на резервация",
      date: "Дата",
      time: "Час",
      amount: "Сума",
      method: "Метод",
      status: "Статус",
      viewDetails: "Виж детайли",
      guests: "Гости",
      package: "Пакет",
      addOns: "Добавки",
      confirmed: "ПОТВЪРДЕНО",
      pending: "ИЗЧАКВАЩО",
      completed: "ЗАВЪРШЕНО",
      cancelled: "ОТМЕНЕНО",
      paid: "ПЛАТЕНО",
    },
    admin: {
      title: "Админ табло",
      description: "Управлявайте вашия Children Planet бизнес",
      totalUsers: "Общо потребители",
      totalBookings: "Общо резервации",
      totalRevenue: "Общи приходи",
      galleryImages: "Снимки в галерията",
      packages: "Пакети",
      bookings: "Резервации",
      users: "Потребители",
      gallery: "Галерия",
      managePackages: "Управление на пакети",
      addPackage: "Добави пакет",
      allBookings: "Всички резервации",
      userManagement: "Управление на потребители",
      userManagementDesc: "Функциите за управление на потребители ще бъдат налични скоро",
      viewEditUsers: "Преглед, редактиране и управление на всички регистрирани потребители",
      galleryManagement: "Управление на галерия",
      uploadPhoto: "Качи снимка",
      featuresIncluded: "включени функции",
      save: "Запази",
      cancel: "Отказ",
      view: "Виж",
      delete: "Изтрий",
      edit: "Редактирай",
      packageName: "Име на пакет",
      price: "Цена",
    },
    footer: {
      description: "Създаваме магически спомени от рождени дни от 2018 г. Ние осигуряваме пространството, вие носите магията!",
      quickLinks: "Бързи връзки",
      support: "Поддръжка",
      visitUs: "Посетете ни",
      contactUs: "Свържете се с нас",
      contractPayment: "Договор и плащане",
      allRightsReserved: "Всички права запазени.",
      partyPackages: "Партийни пакети",
      bookAParty: "Резервирай парти",
      address: "Бургас, България",
      workingHours: "12:00 - 22:00 (вкл. почивни дни)",
    },
    contract: {
      badge: "ДОГОВОР И ПЛАЩАНЕ",
      title: "Договор и плащане",
      subtitle: "Изтеглете нашия договор за наем и научете за възможностите за плащане",
      downloadTitle: "Договор за наем",
      downloadDesc: "Изтеглете договора на предпочитания от вас език",
      downloadButton: "Изтегли договор (PDF)",
      otherLanguages: "Изтегли на други езици:",
      paymentTitle: "Информация за плащане",
      paymentDesc: "Приемаме следните методи на плащане",
      acceptedMethods: "Приети методи на плащане",
      cash: "В брой",
      bankTransfer: "Банков превод",
      downPaymentTitle: "Изисква се капаро",
      downPaymentDesc: "За потвърждаване на резервацията се изисква капаро",
      downPaymentAmount: "от общата сума",
      paymentNote: "Останалите 50% се дължат в деня на събитието",
      questions: "Имате въпроси?",
      contactUs: "Свържете се с нас",
    },
    login: {
      welcome: "Добре дошли! Моля, влезте в своя акаунт.",
      login: "Вход",
      register: "Регистрация",
      emailAddress: "Имейл адрес",
      password: "Парола",
      fullName: "Пълно име",
      confirmPassword: "Потвърди парола",
      signIn: "Влез",
      signingIn: "Влизане...",
      createAccount: "Създай акаунт",
      creatingAccount: "Създаване на акаунт...",
      demoCredentials: "Демо данни:",
      admin: "Админ",
      termsAgreement: "Продължавайки, вие се съгласявате с нашите",
      termsOfService: "Условия за ползване",
      and: "и",
    },
  },
  ru: {
    nav: {
      home: "Главная",
      packages: "Пакеты",
      gallery: "Галерея",
      contract: "Договор и оплата",
      contact: "Контакты",
      login: "Вход",
      logout: "Выход",
      bookNow: "Забронировать",
      dashboard: "Панель",
      admin: "Админ",
    },
    home: {
      heroTitle: "Идеальное пространство для вашего детского праздника",
      heroDescription: "Мы предлагаем уютное и современное кафе в аренду, где вы сможете воплотить в жизнь любые идеи для идеального детского Дня рождения или семейного мероприятия. Наш формат - это полная творческая свобода для организаторов и безопасная среда для маленьких гостей.",
      explorePackages: "Посмотреть пакеты",
      unforgettableBirthdays: "НЕЗАБЫВАЕМЫЕ ДНИ РОЖДЕНИЯ",
      pickYourMagic: "Выберите свою магию!",
      pickDescription: "Выберите идеальный пакет для особенного дня вашего ребёнка. Мы предоставляем пространство, вы создаёте воспоминания!",
      mostPopular: "САМЫЙ ПОПУЛЯРНЫЙ",
      bestValue: "ЛУЧШАЯ ЦЕНА",
      perParty: "/праздник",
      viewAllPackages: "Все пакеты",
      featuresTitle: "Особенности нашего пространства",
      featureFormat: "Формат",
      featureFormatDesc: "Аренда помещения без стороннего персонала. Вы сами планируете сценарий и декор.",
      featureFood: "Питание",
      featureFoodDesc: "Вы можете принести любые любимые угощения, закуски и десерты с собой. Кафе не предоставляет питание.",
      featureDrinks: "Напитки",
      featureDrinksDesc: "Только безалкогольные напитки (соки, лимонады, чай/кофе). Кафе не предоставляет напитки.",
      featureAtmosphere: "Атмосфера",
      featureAtmosphereDesc: "\"Трезвый формат\" - территория, свободная от алкоголя.",
      popularThemes: "Темы праздников",
      themesDescription: "Выберите из наших популярных тем для празднования дней рождения и детских праздников!",
      viewDetails: "Забронировать",
      readyToCreate: "Готовы создать волшебные воспоминания?",
      readyDescription: "Забронируйте праздник сегодня и принесите свою магию в наше пространство!",
      bookYourParty: "Забронировать праздник",
    },
    booking: {
      title: "ЗАБРОНИРОВАТЬ ПРАЗДНИК",
      heading: "Забронируйте волшебный праздник!",
      subtitle: "Давайте сделаем день рождения вашего ребёнка незабываемым",
      step1: "1. Выберите пакет",
      step2: "2. Выберите дату и время",
      step3: "3. Детали праздника",
      workingHours: "Часы работы: 12:00 - 22:00 (включая выходные)",
      partyDate: "Дата праздника",
      partyTime: "Время праздника",
      selectDatePlaceholder: "Выберите дату",
      selectTimePlaceholder: "Выберите время",
      childName: "Имя именинника",
      childAge: "Возраст ребёнка",
      parentName: "Имя родителя/опекуна",
      phone: "Номер телефона",
      email: "Электронная почта",
      guests: "Количество гостей",
      specialRequests: "Особые пожелания (необязательно)",
      specialRequestsPlaceholder: "Диетические ограничения, предпочтения по теме или особые пожелания...",
      summary: "Сводка бронирования",
      packageLabel: "Пакет",
      priceLabel: "Цена",
      dateLabel: "Дата",
      timeLabel: "Время",
      total: "Итого",
      submitButton: "Отправить заявку на бронирование",
      sending: "Отправка...",
      confirmation: "Мы свяжемся с вами в течение 24 часов для подтверждения бронирования",
      selectDate: "Пожалуйста, выберите дату праздника",
      selectTime: "Пожалуйста, выберите время праздника",
      success: "Заявка на бронирование успешно отправлена! Мы скоро свяжемся с вами.",
      error: "Не удалось отправить бронирование. Пожалуйста, попробуйте ещё раз или свяжитесь с нами напрямую.",
    },
    contact: {
      badge: "СВЯЗАТЬСЯ С НАМИ",
      title: "Свяжитесь с нами",
      subtitle: "Есть вопросы? Мы будем рады услышать вас. Отправьте нам сообщение, и мы ответим как можно скорее.",
      visitUs: "Посетите нас",
      address: "Бургас, Болгария",
      callUs: "Позвоните нам",
      emailUs: "Напишите нам",
      replyTime: "Мы отвечаем в течение 24 часов",
      openingHours: "Часы работы",
      workingHours: "12:00 - 22:00",
      includesWeekends: "Включая выходные",
      formTitle: "Отправить сообщение",
      yourName: "Ваше имя",
      emailAddress: "Электронная почта",
      phoneNumber: "Номер телефона",
      subject: "Тема",
      message: "Сообщение",
      messagePlaceholder: "Расскажите, чем мы можем вам помочь...",
      sendMessage: "Отправить сообщение",
      sending: "Отправка...",
      success: "Сообщение успешно отправлено! Мы скоро свяжемся с вами.",
      error: "Не удалось отправить сообщение. Пожалуйста, попробуйте ещё раз.",
    },
    packages: {
      title: "Выберите идеальный пакет",
      description: "Каждый пакет включает наше уютное и современное пространство. Просто выберите любимый и принесите свою магию!",
      readyToBook: "Готовы забронировать?",
      readyDescription: "Выберите пакет и давайте начнём планировать самый запоминающийся праздник!",
      bookNow: "Забронировать сейчас",
    },
    dashboard: {
      welcomeBack: "Добро пожаловать",
      manageBookings: "Управляйте бронированиями и просматривайте историю праздников",
      totalBookings: "Всего бронирований",
      upcoming: "Предстоящие",
      totalSpent: "Всего потрачено",
      account: "Аккаунт",
      active: "Активен",
      myBookings: "Мои бронирования",
      paymentHistory: "История платежей",
      paymentId: "ID платежа",
      bookingId: "ID бронирования",
      date: "Дата",
      time: "Время",
      amount: "Сумма",
      method: "Метод",
      status: "Статус",
      viewDetails: "Подробнее",
      guests: "Гостей",
      package: "Пакет",
      addOns: "Дополнения",
      confirmed: "ПОДТВЕРЖДЕНО",
      pending: "В ОЖИДАНИИ",
      completed: "ЗАВЕРШЕНО",
      cancelled: "ОТМЕНЕНО",
      paid: "ОПЛАЧЕНО",
    },
    admin: {
      title: "Админ панель",
      description: "Управляйте бизнесом Children Planet",
      totalUsers: "Всего пользователей",
      totalBookings: "Всего бронирований",
      totalRevenue: "Общий доход",
      galleryImages: "Изображений в галерее",
      packages: "Пакеты",
      bookings: "Бронирования",
      users: "Пользователи",
      gallery: "Галерея",
      managePackages: "Управление пакетами",
      addPackage: "Добавить пакет",
      allBookings: "Все бронирования",
      userManagement: "Управление пользователями",
      userManagementDesc: "Функции управления пользователями скоро будут доступны",
      viewEditUsers: "Просмотр, редактирование и управление всеми зарегистрированными пользователями",
      galleryManagement: "Управление галереей",
      uploadPhoto: "Загрузить фото",
      featuresIncluded: "включено функций",
      save: "Сохранить",
      cancel: "Отмена",
      view: "Просмотр",
      delete: "Удалить",
      edit: "Редактировать",
      packageName: "Название пакета",
      price: "Цена",
    },
    footer: {
      description: "Создаём волшебные воспоминания о днях рождения с 2018 года. Мы предоставляем пространство, вы приносите магию!",
      quickLinks: "Быстрые ссылки",
      support: "Поддержка",
      visitUs: "Посетите нас",
      contactUs: "Свяжитесь с нами",
      contractPayment: "Договор и оплата",
      allRightsReserved: "Все права защищены.",
      partyPackages: "Праздничные пакеты",
      bookAParty: "Забронировать праздник",
      address: "Бургас, Болгария",
      workingHours: "12:00 - 22:00 (вкл. выходные)",
    },
    contract: {
      badge: "ДОГОВОР И ОПЛАТА",
      title: "Договор и оплата",
      subtitle: "Скачайте наш договор аренды и узнайте о вариантах оплаты",
      downloadTitle: "Договор аренды",
      downloadDesc: "Скачайте договор на предпочитаемом языке",
      downloadButton: "Скачать договор (PDF)",
      otherLanguages: "Скачать на других языках:",
      paymentTitle: "Информация об оплате",
      paymentDesc: "Мы принимаем следующие способы оплаты",
      acceptedMethods: "Принимаемые способы оплаты",
      cash: "Наличные",
      bankTransfer: "Банковский перевод",
      downPaymentTitle: "Требуется предоплата",
      downPaymentDesc: "Для подтверждения бронирования требуется предоплата",
      downPaymentAmount: "от общей суммы",
      paymentNote: "Оставшиеся 50% оплачиваются в день мероприятия",
      questions: "Есть вопросы?",
      contactUs: "Свяжитесь с нами",
    },
    login: {
      welcome: "Добро пожаловать! Войдите в свой аккаунт.",
      login: "Вход",
      register: "Регистрация",
      emailAddress: "Электронная почта",
      password: "Пароль",
      fullName: "Полное имя",
      confirmPassword: "Подтвердите пароль",
      signIn: "Войти",
      signingIn: "Вход...",
      createAccount: "Создать аккаунт",
      creatingAccount: "Создание аккаунта...",
      demoCredentials: "Демо данные:",
      admin: "Админ",
      termsAgreement: "Продолжая, вы соглашаетесь с нашими",
      termsOfService: "Условиями использования",
      and: "и",
    },
  },
};
